import * as React from 'react'

import SEO from '../components/common/SEO'
import TopContent from '../components/top/TopContent'

export type IndexPageProps = {}

const IndexPage: React.FC<IndexPageProps> = () => {
  const seo = {
    title: 'Sense Island -感覚の島- 暗闇の美術島 2021 ―Sense Island Sarushima Dark Island 2021',
    description:
      "アートを通して体感する猿島とその自然。Sensing Sarushima and it's nature through the art work as a lens.",
    path: '/',
  }
  return (
    <>
      <SEO {...seo} />
      <TopContent />
    </>
  )
}

export default IndexPage
